import React, { useEffect, createElement } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { ContactSection } from '../components/ContactSection';
import { motion } from 'framer-motion';
import { Calendar, Users, Gift, Sparkles, Coffee, Utensils, Waves, Droplets, Heart, Wine, Smile } from 'lucide-react';
import { Button } from '../components/ui/Button';
const ourEvents = [{
  title: 'ימי גיבוש לחברות',
  description: 'יום מלא של פעילויות ימיות, משחקי קבוצה ובניית צוות. חוויה שתחזק את הקשרים בצוות ותיצור זיכרונות משותפים.',
  image: 'https://cdn.magicpatterns.com/uploads/6eVwxnd5NhVtYfdQz83Mv5/חברות.jpg',
  color: 'from-blue-500 to-cyan-400'
}, {
  title: 'אירועים משפחתיים',
  description: 'ימי הולדת, בר/בת מצווה, מסיבות משפחתיות ואירועים מיוחדים. יום בלתי נשכח לכל המשפחה על חוף הכנרת.',
  image: 'https://cdn.magicpatterns.com/uploads/9X5FNE8zK66yqawi4si15S/GetAttachmentThumbnail_(1).jpg',
  color: 'from-pink-500 to-rose-400'
}, {
  title: 'סדנאות קונספט',
  description: 'בוקר נשי, מסיבת רווקות או סתם מפגש חברים. חוויה מיוחדת שמחברת בין ים, רוגע וחברות טובה.',
  image: 'https://cdn.magicpatterns.com/uploads/2qPvWfrpuA9zC4zk67VF34/cf6f08e4-6b6e-4138-add5-a6c3e0976860_(1).jpg',
  color: 'from-purple-500 to-pink-400'
}];
const eventIncludes = [{
  icon: Utensils,
  title: 'ארוחות לבחירה',
  description: 'ממגוון תפריטים מותאמים אישית',
  image: 'https://cdn.magicpatterns.com/uploads/9K1K7Y8duPn8u1ZWuc6RZi/IMG_7629.jpg'
}, {
  icon: Waves,
  title: 'שימוש חופשי בציוד חתירה',
  description: 'כל ציוד המועדון והדרכה בסיסית',
  image: 'https://cdn.magicpatterns.com/uploads/uL5iLVfpHFdEsjuc5CjUj3/סאפים.jpg'
}, {
  icon: Coffee,
  title: 'מתקני כפר הנופש',
  description: 'בריכת שחייה וחוף מפנק',
  image: 'https://cdn.magicpatterns.com/uploads/hzvVTdRCydoPmYWgD5KmjT/1000327273.jpg'
}, {
  icon: Waves,
  title: 'טיול סאפים מודרך',
  description: 'חוויה מודרכת על מי הכנרת',
  image: 'https://cdn.magicpatterns.com/uploads/rMrufAv5CVsqC9RME1SMeN/image.png'
}, {
  icon: Heart,
  title: 'תרגול יוגה קבוצתי על הסאפ',
  description: 'שילוב מושלם של רוגע ואיזון',
  image: 'https://cdn.magicpatterns.com/uploads/1i37x3Y3o2Enq3mpME5bRw/יוגה.jpg'
}, {
  icon: Droplets,
  title: 'בריכת קרח',
  description: 'חוויה מרעננת ומחזקת',
  image: 'https://cdn.magicpatterns.com/uploads/sBpCmAgnydbLtGTXjGZ9we/thumbnail_IMG_2737.jpg'
}, {
  icon: Heart,
  title: 'מתחם עיסויים',
  description: 'מטפלים מקצועיים לרוגע מושלם',
  image: 'https://cdn.magicpatterns.com/uploads/ku2nCKD6NhCAd3mEmKjL3n/55D1CBB6-56A8-4025-9FEE-23F89E29A899.jpg'
}, {
  icon: Sparkles,
  title: 'כל דבר אחר שתחלמו עליו',
  description: 'אנחנו נבנה את האירוע המושלם עבורכם',
  image: 'https://cdn.magicpatterns.com/uploads/ozTxaeTJ3uPnJdnbNHjUnP/IMG_7518_(2).jpg'
}];
export function EventsPage() {
  useEffect(() => {
    // Set meta tags for Events page
    document.title = "אירועים וסדנאות | ביץ' קלאב מעגן";
    // Update or create meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'אירועים וסדנאות בכנרת - ימי גיבוש לחברות, אירועים משפחתיים, סדנאות קונספט. חוויה בלתי נשכחת על חוף הכנרת');
    // Open Graph tags
    const ogTags = [{
      property: 'og:title',
      content: "אירועים וסדנאות | ביץ' קלאב מעגן"
    }, {
      property: 'og:description',
      content: 'אירועים וסדנאות בכנרת - ימי גיבוש, אירועים משפחתיים וסדנאות מיוחדות על חוף הכנרת'
    }, {
      property: 'og:type',
      content: 'website'
    }];
    ogTags.forEach(tag => {
      let metaTag = document.querySelector(`meta[property="${tag.property}"]`);
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute('property', tag.property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', tag.content);
    });
  }, []);
  return <div className="min-h-screen bg-white" dir="rtl" data-id="element-937">
      <Navigation data-id="element-938" />

      {/* Hero Section */}
      <div className="relative h-[60vh] overflow-hidden" data-id="element-939">
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-[#0A5F8F]/80 z-10" data-id="element-940" />
        <img src="https://cdn.magicpatterns.com/uploads/p194udREcU8JKLbaUPgaLY/GetAttachmentThumbnail_(3).jpg" alt="Events and Workshops" className="w-full h-full object-cover" data-id="element-941" />
        <div className="absolute inset-0 z-20 flex flex-col items-center justify-center text-center text-white px-4" data-id="element-942">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-943">
            <Calendar className="w-16 h-16 mx-auto mb-6 text-blue-200" data-id="element-944" />
            <h1 className="text-5xl md:text-7xl font-bold mb-4" data-id="element-945">
              אירועים וסדנאות
            </h1>
            <p className="text-xl md:text-2xl max-w-2xl font-light" data-id="element-946">
              חוויות בלתי נשכחות על מי הכנרת
            </p>
          </motion.div>
        </div>
      </div>

      <div className="container mx-auto px-4 py-20" data-id="element-947">
        {/* Introduction */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16 max-w-4xl mx-auto" data-id="element-948">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-6" data-id="element-949">
            אירועים לקבוצות וארגונים בכנרת לחוויה אחרת!
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed" data-id="element-950">
            מועדון ביץ' קלאב בכנרת מזמין אתכם לחוויה מיוחדת שתעצים, תגבש ותיתן
            לכם את האוויר והמרחב שאתם צריכים ליום מושלם ביחד.
          </p>
        </motion.div>

        {/* Our Events Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-951">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-4" data-id="element-952">
            האירועים שלנו
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-953">
            אנחנו מתאימים כל אירוע במיוחד עבורכם
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20 max-w-6xl mx-auto" data-id="element-954">
          {ourEvents.map((event, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group" data-id="element-955">
              <div className="relative h-64 overflow-hidden" data-id="element-956">
                <div className={`absolute inset-0 bg-gradient-to-t ${event.color} opacity-20 z-10`} data-id="element-957" />
                <img src={event.image} alt={event.title} className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700" data-id="element-958" />
              </div>

              <div className="p-8" data-id="element-959">
                <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-960">
                  {event.title}
                </h3>

                <p className="text-gray-600 leading-relaxed" data-id="element-961">
                  {event.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        {/* What's Included Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-20" data-id="element-962">
          <div className="text-center mb-12" data-id="element-963">
            <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-4" data-id="element-964">
              מה כלול באירוע?
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-965">
              <span className="font-bold text-[#0A5F8F]" data-id="element-966">
                אנחנו בונים את האירוע במיוחד עבורכם!
              </span>
              <br data-id="element-967" />
              כל אירוע מותאם אישית לצרכי הלקוח והקבוצה
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-968">
            {eventIncludes.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl border border-blue-100 overflow-hidden" data-id="element-969">
                {item.image ? <div className="relative h-48 overflow-hidden" data-id="element-970">
                    <img src={item.image} alt={item.title} className="w-full h-full object-cover" data-id="element-971" />
                  </div> : <div className="p-6 pb-0" data-id="element-972">
                    <div className="bg-white w-12 h-12 rounded-xl flex items-center justify-center shadow-sm" data-id="element-973">
                      <item.icon className="w-6 h-6 text-[#0A5F8F]" data-id="element-974" />
                    </div>
                  </div>}
                <div className="p-6" data-id="element-975">
                  <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-976">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-977">{item.description}</p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>

        {/* Institutional Programs CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12 bg-white border border-slate-200 rounded-3xl overflow-hidden shadow-sm" data-id="element-978">
          <div className="grid md:grid-cols-5 gap-0" data-id="element-979">
            <div className="md:col-span-2 relative h-64 md:h-auto overflow-hidden" data-id="element-980">
              <img src="https://cdn.magicpatterns.com/uploads/rMrufAv5CVsqC9RME1SMeN/image.png" alt="מרחב בטוח על המים" className="w-full h-full object-cover" data-id="element-981" />
              <div className="absolute inset-0 bg-gradient-to-l from-slate-900/60 to-transparent md:bg-gradient-to-l md:from-white/0 md:via-transparent md:to-transparent" data-id="element-982" />
            </div>
            <div className="md:col-span-3 p-8 md:p-10 flex flex-col justify-center" data-id="element-983">
              <div className="inline-flex items-center gap-2 py-1 px-3 rounded-full bg-sky-100 text-sky-700 text-xs font-semibold w-fit mb-3" data-id="element-984">
                לעמותות ומחלקות רווחה
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-slate-900 mb-3 leading-tight" data-id="element-985">
                מרחב בטוח על המים – תוכניות חוסן והעצמה
              </h3>
              <p className="text-slate-600 leading-relaxed mb-6" data-id="element-986">
                תהליך טיפולי-שיקומי מובנה דרך הגוף והטבע. שילוב של חתירת סאפ,
                מיינדפולנס ועיבוד קבוצתי, מותאם אישית לקהל היעד של הארגון שלכם –
                שורדי טראומה, נפגעי נפש, נוער בסיכון ועוד.
              </p>
              <a href="/safe-space-on-water" className="inline-flex items-center gap-2 bg-sky-600 hover:bg-sky-700 text-white font-bold py-3 px-6 rounded-full transition-all shadow-md shadow-sky-600/20 hover:scale-[1.02] w-fit" data-id="element-987">
                לפרטים על התוכנית ←
              </a>
            </div>
          </div>
        </motion.div>

        {/* Custom Events CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-[#0A5F8F] to-[#0D7AB8] rounded-3xl p-12 text-center text-white relative overflow-hidden" data-id="element-988">
          <div className="absolute inset-0 opacity-10" data-id="element-989">
            <div className="absolute inset-0" style={{
            backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
            backgroundSize: '40px 40px'
          }} data-id="element-990" />
          </div>

          <div className="relative z-10" data-id="element-991">
            <Sparkles className="w-16 h-16 mx-auto mb-6 text-blue-200" data-id="element-992" />
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-993">
              רוצים לארגן אירוע מיוחד?
            </h2>
            <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto" data-id="element-994">
              נשמח לעזור לכם לתכנן את האירוע המושלם - ימי גיבוש, חגיגות
              משפחתיות, סדנאות ועוד
            </p>
            <a href="tel:0522632784" data-id="element-995">
              <Button size="lg" className="bg-gradient-to-r from-blue-600 to-cyan-500 text-white hover:from-blue-700 hover:to-cyan-600 font-bold shadow-lg hover:shadow-xl transition-all" data-id="element-996">
                דברו איתנו לפרטים נוספים
              </Button>
            </a>
          </div>
        </motion.div>
      </div>

      <ContactSection data-id="element-997" />
      <Footer data-id="element-998" />
    </div>;
}